module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AgreementProfile"
  }, [_c('h1', {
    staticClass: "m-label",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n    契約基本情報\n  ")]), _vm._v(" "), (_vm.agreement.id == _vm.edit_id.agreement_id) ? [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.patchAgreement(_vm.agreement)
      }
    }
  }, [_c('div', {
    staticClass: "m-box__inner"
  }, [_c('table', {
    staticClass: "m-detail"
  }, [(!_vm.valid) ? [_c('tr', [_c('th', [_vm._v("エラー")]), _vm._v(" "), _c('td', {
    staticClass: "errors"
  }, [_c('div', [_vm._v(_vm._s(_vm.errors) + "が入力されていません")])])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("給与計算")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.payroll_check),
      expression: "agreement.payroll_check"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "給与計算チェック"
    },
    domProps: {
      "value": (_vm.agreement.payroll_check)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "payroll_check", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.id))]), _vm._v(" "), _c('th', [_vm._v("生徒ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.student_id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("契約者名")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.f_name),
      expression: "agreement.f_name"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "placeholder": "姓"
    },
    domProps: {
      "value": (_vm.agreement.f_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "f_name", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.l_name),
      expression: "agreement.l_name"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "placeholder": "名"
    },
    domProps: {
      "value": (_vm.agreement.l_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "l_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("契約者名(かな)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.f_name_kana),
      expression: "agreement.f_name_kana"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "placeholder": "せい"
    },
    domProps: {
      "value": (_vm.agreement.f_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "f_name_kana", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.l_name_kana),
      expression: "agreement.l_name_kana"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "placeholder": "めい"
    },
    domProps: {
      "value": (_vm.agreement.l_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "l_name_kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("住所")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.address),
      expression: "agreement.address"
    }],
    attrs: {
      "type": "text",
      "placeholder": "住所"
    },
    domProps: {
      "value": (_vm.agreement.address)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("住所2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.address2),
      expression: "agreement.address2"
    }],
    attrs: {
      "type": "text",
      "placeholder": "住所2"
    },
    domProps: {
      "value": (_vm.agreement.address2)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "address2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("携帯TEL")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.tel),
      expression: "agreement.tel"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "11",
      "minlength": "10",
      "placeholder": "携帯TEL"
    },
    domProps: {
      "value": (_vm.agreement.tel)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "tel", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("固定TEL")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.tel2),
      expression: "agreement.tel2"
    }],
    attrs: {
      "type": "text",
      "maxlength": "11",
      "minlength": "10",
      "placeholder": "固定TEL"
    },
    domProps: {
      "value": (_vm.agreement.tel2)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "tel2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("契約種類")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "required": "",
      "options": _vm.contract_type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "契約種類"
    },
    model: {
      value: (_vm.watch.contract_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "contract_type", $$v)
      },
      expression: "watch.contract_type"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("契約日付")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.contract_date),
      expression: "agreement.contract_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "契約日付"
    },
    domProps: {
      "value": (_vm.agreement.contract_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "contract_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("担当者")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.person),
      expression: "agreement.person"
    }],
    attrs: {
      "type": "text",
      "placeholder": "担当者"
    },
    domProps: {
      "value": (_vm.agreement.person)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "person", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("内容変更日付")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.change_date),
      expression: "agreement.change_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "内容変更日付"
    },
    domProps: {
      "value": (_vm.agreement.change_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "change_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("解約種類")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.cancel_type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "解約種類"
    },
    model: {
      value: (_vm.watch.cancel_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "cancel_type", $$v)
      },
      expression: "watch.cancel_type"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("解約日付")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.cancel_date),
      expression: "agreement.cancel_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "キャンセル日付"
    },
    domProps: {
      "value": (_vm.agreement.cancel_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "cancel_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("商品名")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.product_name),
      expression: "agreement.product_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "商品名"
    },
    domProps: {
      "value": (_vm.agreement.product_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "product_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("合計ポイント")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.point_total),
      expression: "agreement.point_total"
    }],
    attrs: {
      "type": "number",
      "step": "0.05",
      "maxlength": "5",
      "placeholder": "合計ポイント"
    },
    domProps: {
      "value": (_vm.agreement.point_total)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "point_total", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "req"
  }, [_vm._v("支払方法種別")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.payment_type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "支払方法種別"
    },
    model: {
      value: (_vm.watch.payment_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "payment_type", $$v)
      },
      expression: "watch.payment_type"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("テキスト種類")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.text_type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "テキスト種類"
    },
    model: {
      value: (_vm.watch.text_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "text_type", $$v)
      },
      expression: "watch.text_type"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("定価")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.amount),
      expression: "agreement.amount"
    }],
    attrs: {
      "type": "text",
      "placeholder": "定価"
    },
    domProps: {
      "value": (_vm.agreement.amount)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("値引")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.discount),
      expression: "agreement.discount"
    }],
    attrs: {
      "type": "text",
      "placeholder": "値引"
    },
    domProps: {
      "value": (_vm.agreement.discount)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "discount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("販売価格")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "販売価格"
    },
    domProps: {
      "value": _vm.pure_amount
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("分割手数料")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.division_commission),
      expression: "agreement.division_commission"
    }],
    attrs: {
      "type": "text",
      "placeholder": "分割手数料"
    },
    domProps: {
      "value": (_vm.agreement.division_commission)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "division_commission", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("お支払総額")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "お支払総額"
    },
    domProps: {
      "value": _vm.total_amount
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("支払回数")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.payments_number,
      "label": "name",
      "searchable": true,
      "show-labels": false,
      "placeholder": "支払回数"
    },
    model: {
      value: (_vm.watch.payments_number),
      callback: function($$v) {
        _vm.$set(_vm.watch, "payments_number", $$v)
      },
      expression: "watch.payments_number"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("テキスト代入金日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.deposit_amount_date),
      expression: "agreement.deposit_amount_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "テキスト代入金日"
    },
    domProps: {
      "value": (_vm.agreement.deposit_amount_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "deposit_amount_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("支払期間/開始(テキスト)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.text_payment_period_start),
      expression: "agreement.text_payment_period_start"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "支払期間/開始(テキスト)"
    },
    domProps: {
      "value": (_vm.agreement.text_payment_period_start)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "text_payment_period_start", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("支払期間/終了(テキスト)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.text_payment_period_end),
      expression: "agreement.text_payment_period_end"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "支払期間/終了(テキスト)"
    },
    domProps: {
      "value": (_vm.agreement.text_payment_period_end)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "text_payment_period_end", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("役務期間/開始")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.service_period_start),
      expression: "agreement.service_period_start"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務期間/開始"
    },
    domProps: {
      "value": (_vm.agreement.service_period_start)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "service_period_start", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "req"
  }, [_vm._v("役務期間/終了")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.service_period_end),
      expression: "agreement.service_period_end"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務期間/終了"
    },
    domProps: {
      "value": (_vm.agreement.service_period_end)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "service_period_end", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("初月管理費支払方法")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.method,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "初月管理費支払方法"
    },
    model: {
      value: (_vm.watch.first_month_deposit_method),
      callback: function($$v) {
        _vm.$set(_vm.watch, "first_month_deposit_method", $$v)
      },
      expression: "watch.first_month_deposit_method"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("初月管理費チェック")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.first_month_deposit_check),
      expression: "agreement.first_month_deposit_check"
    }],
    attrs: {
      "type": "text",
      "placeholder": "初月管理費チェック"
    },
    domProps: {
      "value": (_vm.agreement.first_month_deposit_check)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "first_month_deposit_check", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("入会金")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.admission_fee),
      expression: "agreement.admission_fee"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "入会金"
    },
    domProps: {
      "value": (_vm.agreement.admission_fee)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "admission_fee", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("入会金支払方法")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.method,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "入会金支払方法"
    },
    model: {
      value: (_vm.watch.admission_fee_method),
      callback: function($$v) {
        _vm.$set(_vm.watch, "admission_fee_method", $$v)
      },
      expression: "watch.admission_fee_method"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("入会金チェック")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.admission_fee_check),
      expression: "agreement.admission_fee_check"
    }],
    attrs: {
      "type": "text",
      "placeholder": "入会金チェック"
    },
    domProps: {
      "value": (_vm.agreement.admission_fee_check)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "focus": _vm.focusAdmission_fee_check,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "admission_fee_check", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("保証金")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.deposit),
      expression: "agreement.deposit"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "保証金"
    },
    domProps: {
      "value": (_vm.agreement.deposit)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "deposit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("保証金支払方法")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.method,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "保証金支払方法"
    },
    model: {
      value: (_vm.watch.deposit_method),
      callback: function($$v) {
        _vm.$set(_vm.watch, "deposit_method", $$v)
      },
      expression: "watch.deposit_method"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("保証金チェック")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.deposit_check),
      expression: "agreement.deposit_check"
    }],
    attrs: {
      "type": "text",
      "placeholder": "保証金チェック"
    },
    domProps: {
      "value": (_vm.agreement.deposit_check)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "focus": _vm.focusDeposit_check,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "deposit_check", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("銀行番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.bank_number),
      expression: "agreement.bank_number"
    }],
    attrs: {
      "type": "text",
      "placeholder": "銀行番号"
    },
    domProps: {
      "value": (_vm.agreement.bank_number)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "bank_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("支店番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.branch_number),
      expression: "agreement.branch_number"
    }],
    attrs: {
      "type": "text",
      "placeholder": "支店番号"
    },
    domProps: {
      "value": (_vm.agreement.branch_number)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "branch_number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("預金種目")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.deposit_item,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "預金種目"
    },
    model: {
      value: (_vm.watch.deposit_item),
      callback: function($$v) {
        _vm.$set(_vm.watch, "deposit_item", $$v)
      },
      expression: "watch.deposit_item"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("口座番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.account_number),
      expression: "agreement.account_number"
    }],
    attrs: {
      "type": "text",
      "placeholder": "口座番号"
    },
    domProps: {
      "value": (_vm.agreement.account_number)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "account_number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("口座名義")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.account_holder),
      expression: "agreement.account_holder"
    }],
    attrs: {
      "type": "text",
      "placeholder": "口座名義"
    },
    domProps: {
      "value": (_vm.agreement.account_holder)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "account_holder", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("保証金返金予定日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.expected_refund_date),
      expression: "agreement.expected_refund_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "保証金返金予定日"
    },
    domProps: {
      "value": (_vm.agreement.expected_refund_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "expected_refund_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("保証金返金日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.deposit_refund_date),
      expression: "agreement.deposit_refund_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "保証金返金日"
    },
    domProps: {
      "value": (_vm.agreement.deposit_refund_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "deposit_refund_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("承認No.")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.approval_number),
      expression: "agreement.approval_number"
    }],
    attrs: {
      "type": "text",
      "maxlength": "13",
      "placeholder": "承認No."
    },
    domProps: {
      "value": (_vm.agreement.approval_number)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "approval_number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("承認日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.approval_date),
      expression: "agreement.approval_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "承認日"
    },
    domProps: {
      "value": (_vm.agreement.approval_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "approval_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.grade),
      expression: "agreement.grade"
    }],
    attrs: {
      "type": "text",
      "placeholder": "学年"
    },
    domProps: {
      "value": (_vm.agreement.grade)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "grade", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("納品日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.delivery_date),
      expression: "agreement.delivery_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "納品日"
    },
    domProps: {
      "value": (_vm.agreement.delivery_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "delivery_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("契約書回収日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.contract_collection_date),
      expression: "agreement.contract_collection_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "契約書回収日"
    },
    domProps: {
      "value": (_vm.agreement.contract_collection_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "contract_collection_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ファクター回収日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.factor_collection_date),
      expression: "agreement.factor_collection_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "ファクター回収日"
    },
    domProps: {
      "value": (_vm.agreement.factor_collection_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "factor_collection_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ファクターチェック")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.factor_check,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "ファクターチェック"
    },
    model: {
      value: (_vm.watch.factor_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "factor_check", $$v)
      },
      expression: "watch.factor_check"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("経理台帳入力")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.ledger_check,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "経理台帳入力"
    },
    model: {
      value: (_vm.watch.ledger_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "ledger_check", $$v)
      },
      expression: "watch.ledger_check"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CXLチェック")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.cancel_check,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "CXLチェック"
    },
    model: {
      value: (_vm.watch.cancel_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "cancel_check", $$v)
      },
      expression: "watch.cancel_check"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("内容変更チェック")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.change_check,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "内容変更チェック"
    },
    model: {
      value: (_vm.watch.change_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "change_check", $$v)
      },
      expression: "watch.change_check"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement.note),
      expression: "agreement.note"
    }],
    attrs: {
      "type": "text",
      "placeholder": "備考"
    },
    domProps: {
      "value": (_vm.agreement.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agreement, "note", $event.target.value)
      }
    }
  })])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn', {
    staticClass: "m-btn m-btn--default"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("更新")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn m-btn--default cancel",
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelAgreement(_vm.agreement)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("キャンセル")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.agreement.id !== _vm.edit_id.agreement_id) ? [_c('div', {
    staticClass: "m-box__inner"
  }, [_c('table', {
    staticClass: "m-detail"
  }, [(!_vm.valid) ? void 0 : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("給与計算")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.payroll_check))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.id))]), _vm._v(" "), _c('th', [_vm._v("生徒ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.student_id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("契約者名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.f_name) + " " + _vm._s(_vm.agreement.l_name))]), _vm._v(" "), _c('th', [_vm._v("契約者名(かな)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.f_name_kana) + " " + _vm._s(_vm.agreement.l_name_kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("住所")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.address))]), _vm._v(" "), _c('th', [_vm._v("住所2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.address2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("携帯TEL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.tel))]), _vm._v(" "), _c('th', [_vm._v("固定TEL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.tel2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("契約種類")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.contract_type))]), _vm._v(" "), _c('th', [_vm._v("契約日付")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.contract_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("担当者")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.person))]), _vm._v(" "), _c('th', [_vm._v("内容変更日付")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.change_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("解約種類")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.cancel_type))]), _vm._v(" "), _c('th', [_vm._v("解約日付")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.cancel_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("商品名")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.agreement.product_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("合計ポイント")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.point_total))]), _vm._v(" "), _c('th', [_vm._v("支払方法種別")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.payment_type))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("テキスト種類")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.text_type))]), _vm._v(" "), _c('th', [_vm._v("定価")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("値引")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.discount))]), _vm._v(" "), _c('th', [_vm._v("販売価格")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.pure_amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("分割手数料")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.division_commission))]), _vm._v(" "), _c('th', [_vm._v("お支払総額")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.total_amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("支払回数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.payments_number))]), _vm._v(" "), _c('th', [_vm._v("テキスト代入金日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.deposit_amount_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("支払期間/開始(テキスト)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.text_payment_period_start))]), _vm._v(" "), _c('th', [_vm._v("支払期間/終了(テキスト)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.text_payment_period_end))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("役務期間/開始")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.service_period_start))]), _vm._v(" "), _c('th', [_vm._v("役務期間/終了")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.service_period_end))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("初月管理費支払方法")]), _vm._v(" "), _c('td', [(_vm.agreement.first_month_deposit_method === 0) ? void 0 : _vm._e(), _vm._v(" "), (_vm.agreement.first_month_deposit_method === 1) ? [_vm._v("振込")] : _vm._e(), _vm._v(" "), (_vm.agreement.first_month_deposit_method === 2) ? [_vm._v("現金")] : _vm._e(), _vm._v(" "), (_vm.agreement.first_month_deposit_method === 3) ? [_vm._v("Coiney")] : _vm._e()], 2), _vm._v(" "), _c('th', [_vm._v("初月管理費チェック")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.first_month_deposit_check))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("入会金")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.admission_fee))]), _vm._v(" "), _c('th', [_vm._v("入会金支払方法")]), _vm._v(" "), _c('td', [(_vm.agreement.admission_fee_method === 0) ? void 0 : _vm._e(), _vm._v(" "), (_vm.agreement.admission_fee_method === 1) ? [_vm._v("振込")] : _vm._e(), _vm._v(" "), (_vm.agreement.admission_fee_method === 2) ? [_vm._v("現金")] : _vm._e(), _vm._v(" "), (_vm.agreement.admission_fee_method === 3) ? [_vm._v("Coiney")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("入会金チェック")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.agreement.admission_fee_check))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("保証金")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.deposit))]), _vm._v(" "), _c('th', [_vm._v("保証金支払方法")]), _vm._v(" "), _c('td', [(_vm.agreement.deposit_method === 0) ? void 0 : _vm._e(), _vm._v(" "), (_vm.agreement.deposit_method === 1) ? [_vm._v("振込")] : _vm._e(), _vm._v(" "), (_vm.agreement.deposit_method === 2) ? [_vm._v("現金")] : _vm._e(), _vm._v(" "), (_vm.agreement.deposit_method === 3) ? [_vm._v("Coiney")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("保証金チェック")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.deposit_check))]), _vm._v(" "), _c('th', [_vm._v("銀行番号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.bank_number))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("支店番号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.branch_number))]), _vm._v(" "), _c('th', [_vm._v("預金種目")]), _vm._v(" "), _c('td', [(_vm.agreement.deposit_item === 0) ? void 0 : _vm._e(), _vm._v(" "), (_vm.agreement.deposit_item === 1) ? [_vm._v("普通")] : _vm._e(), _vm._v(" "), (_vm.agreement.deposit_item === 2) ? [_vm._v("当座")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("口座番号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.account_number))]), _vm._v(" "), _c('th', [_vm._v("口座名義")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.account_holder))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("保証金返金予定日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.expected_refund_date))]), _vm._v(" "), _c('th', [_vm._v("保証金返金日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.deposit_refund_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("承認No.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.approval_number))]), _vm._v(" "), _c('th', [_vm._v("承認日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.approval_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.grade))]), _vm._v(" "), _c('th', [_vm._v("納品日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.delivery_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("契約書回収日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.contract_collection_date))]), _vm._v(" "), _c('th', [_vm._v("ファクター回収日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.agreement.factor_collection_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ファクターチェック")]), _vm._v(" "), _c('td', [(_vm.agreement.factor_check === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.agreement.factor_check === 1) ? [_vm._v("済")] : _vm._e(), _vm._v(" "), (_vm.agreement.factor_check === 2) ? [_vm._v("未")] : _vm._e(), _vm._v(" "), (_vm.agreement.factor_check === 3) ? [_vm._v("無")] : _vm._e()], 2), _vm._v(" "), _c('th', [_vm._v("経理台帳入力")]), _vm._v(" "), _c('td', [(_vm.agreement.ledger_check === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.agreement.ledger_check === 1) ? [_vm._v("済")] : _vm._e(), _vm._v(" "), (_vm.agreement.ledger_check === 2) ? [_vm._v("未")] : _vm._e(), _vm._v(" "), (_vm.agreement.ledger_check === 3) ? [_vm._v("無")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CXLチェック")]), _vm._v(" "), _c('td', [(_vm.agreement.cancel_check === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.agreement.cancel_check === 1) ? [_vm._v("済")] : _vm._e(), _vm._v(" "), (_vm.agreement.cancel_check === 2) ? [_vm._v("未")] : _vm._e(), _vm._v(" "), (_vm.agreement.cancel_check === 3) ? [_vm._v("無")] : _vm._e()], 2), _vm._v(" "), _c('th', [_vm._v("内容変更チェック")]), _vm._v(" "), _c('td', [(_vm.agreement.change_check === 0) ? [_vm._v("未選択")] : _vm._e(), _vm._v(" "), (_vm.agreement.change_check === 1) ? [_vm._v("済")] : _vm._e(), _vm._v(" "), (_vm.agreement.change_check === 2) ? [_vm._v("未")] : _vm._e(), _vm._v(" "), (_vm.agreement.change_check === 3) ? [_vm._v("無")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.agreement.note))])])], 2)]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.edit(_vm.agreement)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("編集")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26b65726"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Profile/AgreementProfile.vue
// module id = 1314
// module chunks = 0